import { ApiError } from "@/services/api/errors";

type TranslateFn = (key: string) => string;

/**
 * Resolves a user-facing error message for a settings CRUD handler
 * (busy/try/catch/finally shape): a 429 response always maps to the shared
 * "rate limited" message, an `ApiError` carrying a server-provided message
 * shows that message verbatim, and anything else falls back to the
 * caller-supplied i18n key.
 */
export function resolveApiErrorMessage(
  err: unknown,
  fallbackKey: string,
  t: TranslateFn,
): string {
  if (err instanceof ApiError && err.status === 429) {
    return t("settings:errors.rateLimited");
  }
  if (err instanceof ApiError && err.message) {
    return err.message;
  }
  return t(fallbackKey);
}
